  <div class="spacer"></div>
  <app-audit-trail-rules-grid [ruleProfileId]="ruleProfileId" (rowClicked)="onRowClick($event)"></app-audit-trail-rules-grid>
